/* amphr-card-video.js — plays the card's second-slot clip while the pointer is
 * on the card.
 *
 * The markup mirrors the photo case: a <video class="alt"> stacked over the
 * primary shot, revealed by the same CSS opacity rule. Only playback needs
 * scripting, because preload="none" means the file has not been fetched when
 * the pointer arrives.
 *
 * Listeners are delegated from document: cards arrive from the collection grid,
 * from search results and from sections fetched over AJAX, so binding per card
 * would miss whatever loads later.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function videoOf(node) {
    var card = node && node.closest && node.closest('.card');
    return card ? card.querySelector('video[data-card-video]') : null;
  }

  function play(video) {
    if (!video || reduceMotion.matches) return;
    var started = video.play();
    /* Rejects when the browser declines to start — the poster stays, which is
       exactly the photo-only behaviour, so there is nothing to report. */
    if (started && started.catch) started.catch(function () {});
  }

  function stop(video) {
    if (!video) return;
    video.pause();
    /* Back to the first frame, so the next hover is not a resumed middle. */
    video.currentTime = 0;
  }

  document.addEventListener('mouseover', function (e) {
    var video = videoOf(e.target);
    if (video) play(video);
  });

  document.addEventListener('mouseout', function (e) {
    var video = videoOf(e.target);
    if (!video) return;
    /* Moving between children of the same card is not leaving it. */
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.card') === video.closest('.card')) return;
    stop(video);
  });

  /* Keyboard: focusing the product link is the equivalent of hovering the card. */
  document.addEventListener('focusin', function (e) {
    var video = videoOf(e.target);
    if (video) play(video);
  });

  document.addEventListener('focusout', function (e) {
    var video = videoOf(e.target);
    if (!video) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.card') === video.closest('.card')) return;
    stop(video);
  });
})();
